import React from 'react';
import { useField } from 'formik';

type EmailFieldProps = {
  name: string;
  id: string;
  wrapperClassName?: string;
  className?: string;
  fieldRef?: React.Ref<HTMLInputElement>;
  placeholder?: string;
  cypressId?: string;
  isDisabled?: boolean;
  isLabelHidden?: boolean;
  label: string;
  helpText?: string;
};

export const EmailField = ({
  name,
  id,
  className = '',
  fieldRef = null,
  placeholder = '',
  cypressId = '',
  isDisabled = false,
  isLabelHidden = false,
  label,
  helpText = '',
}: EmailFieldProps) => {
  const [field, meta] = useField(name);
  const showErrors = meta.touched && meta.error;
  const wrapperClassName = showErrors ? 'boxField boxField--error' : 'boxField';
  return (
    <div className={wrapperClassName}>
      <input
        {...field}
        id={id}
        type='email'
        name={name}
        className={className}
        ref={fieldRef}
        placeholder={placeholder}
        data-cy={cypressId}
        disabled={isDisabled}
      />
      <label htmlFor={id} className={isLabelHidden ? 'hide_accessibly' : ''}>
        {label}
      </label>
      {helpText && <p className='field__helpText'>{helpText}</p>}
      {showErrors && <p className='field__errorMessage'>{meta.error}</p>}
    </div>
  );
};

export default EmailField;
